import React, { useEffect, useState } from "react";
import {
  Paper,
  Button,
  TextField,
  Grid,
  Box,
  Typography,
  InputAdornment,
  IconButton,
  Link,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { useForm } from "react-hook-form";
import logo from "../../assets/img/logo.png";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate, useLocation } from "react-router-dom";
import { useNotificationContext } from "../../common/NotificationContext";
import { useLoading } from "../../common/LoadingContext";
import { VERIFY_TOKEN_PASSWORD } from "../../utils/Validation";
import { yupResolver } from "@hookform/resolvers/yup";

import {
  confirmMatchedPassword,
  containSpecialCharacters,
  hasLowerCase,
  hasNumber,
  hasUpperCase,
  lengthGreaterThan,
} from "../../utils/jsUtils";

import CheckerComponent from "../../common/CheckerComponent";
import ForgotPasswordService, {
  changeForgotPassword,
} from "../../services/forgotPassword";
import useGlobalState from "./../../Context";
import { logout, setIsLoggedIn } from "../../reducer/action";

const ResetPassword = (props) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [userId, setUserId] = useState(null);
  const [, dispatch] = useGlobalState();

  const { showNotification } = useNotificationContext();
  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const formOption = {
    resolver: yupResolver(VERIFY_TOKEN_PASSWORD),
  };
  const {
    register,

    handleSubmit,
    formState: { errors },
    watch,
  } = useForm(formOption);

  const location = useLocation();
  // const userId = userDetails?.userParam?.userId;
  // const userId = searchParams?.get("userId");
  const onInitialLoad = async (userId) => {
    const param = {
      userId: userId,
    };
    try {
      setLoading(true);

      const forgotPasswordResponse = await ForgotPasswordService(
        baseUrl,
        param
      );
      if (forgotPasswordResponse?.messageCode === 6) {
        showNotification(
          "Success",
          forgotPasswordResponse?.message ??
            "Confirmation Code Sent to Registered Email Id For Initial Password Change",
          "success"
        );
      } else {
        showNotification(
          "Error",
          forgotPasswordResponse?.message ?? "Failed to Reset Password"
        );
      }
    } catch (e) {
      showNotification("Error", e?.message ?? "Failed to Reset Password");
    } finally {
      setLoading(false);
    }
  };

  const logoutMethod = async () => {
    try {
      setLoading(true);
      dispatch(setIsLoggedIn(false));
      dispatch(logout());
      navigate("/login");
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed to Logout");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    // if (
    //   userId &&
    //   isEmptyObject(userDetails?.userParam) &&
    //   isEmptyObject(userDetails?.userParam?.userId)
    // ) {
    //   navigate("/");
    // }
    if (location && location?.state) {
      onInitialLoad(location?.state?.userId);
      setUserId(location?.state?.userId);
    } else {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const param = {
        userId: userId,
        resetCode: data?.token?.trim(),
        newPassword: window.btoa(data?.password?.trim()),
        confirmPassword: window.btoa(data?.confirm_password?.trim()),
      };

      const response = await changeForgotPassword(baseUrl, param);

      if (response?.messageCode === 6) {
        showNotification(
          "Success",
          response?.message ?? "Password updated",
          "success"
        );
        await logoutMethod();
        navigate("/login");
      } else {
        showNotification(
          "Error",
          response?.message ?? "Failed To Reset Password"
        );
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed To Reset Password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Paper elevation={3}>
        <Grid container sx={{ background: "#fff", height: "100vh" }}>
          <Grid
            item
            xs={6}
            md={6}
            sx={{
              background:
                "linear-gradient( 40deg, rgba(67, 138, 243, 0.7), rgba(255, 242, 166, 0.7) )",
              // background: "linear-gradient(61deg,#5a83c3ab, #aa9dca6b)",
            }}
          >
            <Box p={2} mt={8}>
              <div className="logoContainer mb20">
                <img src={logo} alt="Logo" />
                <div className="projectLogo">
                  <div title="Dock Appointment">DAS</div>
                  <div className="projectTitle">Dock Appointment System</div>
                </div>
              </div>
            </Box>

            {/* <Typography color="primary" sx={{ my: 3, pt: 2, fontSize: "20px" }}>
              To keep connected with us <br />
              please login with your personal info
            </Typography> */}
            {/* <Grid item xs={12} md={12}> */}
            <Box
              alignContent={"center"}
              sx={{ my: 3, pt: 0, mt: 0, display: "inline-grid" }}
            >
              <Box display={"flex"} alignItems="center" mt={8}>
                <LockIcon
                  fontSize={"medium"}
                  sx={{ color: "primary", mr: 1 }}
                />
                <Typography
                  fontSize={"22px"}
                  variant={"body1"}
                  textAlign="center"
                  fontWeight={"600"}
                  color={"primary"}
                >
                  Password Composition -
                </Typography>
              </Box>

              <Box ml={1} alignContent={"center"}>
                <CheckerComponent
                  className="font13"
                  label={"Contains at least 8 characters."}
                  isCheck={lengthGreaterThan(8, watch("password", ""))}
                ></CheckerComponent>
                <CheckerComponent
                  className="font13"
                  label={"Contains uppercase characters."}
                  isCheck={hasUpperCase(watch("password", ""))}
                ></CheckerComponent>
                <CheckerComponent
                  className="font13"
                  label={"Contains lowercase characters."}
                  isCheck={hasLowerCase(watch("password", ""))}
                ></CheckerComponent>
                <CheckerComponent
                  className="font13"
                  label={"Contains numerical characters."}
                  isCheck={hasNumber(watch("password", ""))}
                ></CheckerComponent>
                <CheckerComponent
                  className="font13"
                  label={"Contains special characters."}
                  isCheck={containSpecialCharacters(watch("password", ""))}
                ></CheckerComponent>
                <CheckerComponent
                  className="font13"
                  label={"Password must match."}
                  isCheck={confirmMatchedPassword(
                    watch("confirm_password", ""),
                    watch("password", "")
                  )}
                ></CheckerComponent>
              </Box>
            </Box>
            {/* </Grid> */}
          </Grid>

          <Grid item xs={6} md={6} sx={{ p: 2, mt: 8 }}>
            <Box sx={{ mt: 10 }}>
              <Typography
                variant="h4"
                color="primary"
                fontWeight={400}
                sx={{ mt: "3", mb: 3 }}
              >
                Change Password
              </Typography>
              <Grid item xs={12} mt={7} px={3}>
                {/* <TextField
                  sx={{ my: 4 }}
                  margin="normal"
                  className="signinText"
                  required
                  fullWidth
                  label="Token "
                  name="token"
                  autoComplete="off"
                  {...register("token", {
                    required: true,
                  })}
                  error={Boolean(errors?.token)}
                  helperText={errors?.token?.message}
                /> */}
                <Typography variant="">
                  Please Enter Confirmation Code Sent to Registered Email Id For
                  Initial Password Change
                </Typography>
                <TextField
                  sx={{ mb: 4 }}
                  margin="normal"
                  className="signinText"
                  required
                  fullWidth
                  name="token"
                  label="Confirmation Code"
                  type={"text"}
                  {...register("token")}
                  error={Boolean(errors?.token)}
                  helperText={errors?.token?.message}
                />
                <TextField
                  sx={{ my: 4 }}
                  margin="normal"
                  className="signinText"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  {...register("password")}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <IconButton
                          color="primary"
                          onClick={() => {
                            setShowPassword((prevValue) => !prevValue);
                          }}
                        >
                          {showPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={Boolean(errors?.password)}
                  helperText={errors?.password?.message}
                />
                <TextField
                  sx={{ mb: 4 }}
                  margin="normal"
                  className="signinText"
                  required
                  fullWidth
                  name="confirm_password"
                  label="Confirm Password"
                  type={showCPassword ? "text" : "password"}
                  {...register("confirm_password")}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <IconButton
                          color="primary"
                          onClick={() => {
                            setShowCPassword((prevValue) => !prevValue);
                          }}
                        >
                          {showCPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={Boolean(errors?.confirm_password)}
                  helperText={errors?.confirm_password?.message}
                />
                <Button
                  type="button"
                  fullWidth
                  size="large"
                  variant="contained"
                  sx={{ mt: 3, mb: 2, color: "white" }}
                  onClick={handleSubmit(onSubmit)}
                >
                  Submit
                </Button>
                <Grid container mt={2}>
                  <Grid item xs={6} sx={{ textAlign: "left" }}>
                    {/* <Typography variant="body1" color={"grey"}>
                        New User?{" "}
                        <Link
                          component="button"
                          variant="text"
                          color="primary"
                          onClick={() => navigate("/login")}
                          sx={{ color: "#003f93" }}
                        >
                          Register
                        </Link>
                      </Typography> */}
                  </Grid>
                  <Grid item xs={6} sx={{ textAlign: "right" }}>
                    <Link
                      // eslint-disable-next-line no-script-url
                      component="button"
                      color="#003f93"
                      variant="body1"
                      onClick={() => navigate("/login")}
                    >
                      {"Back to Sign In"}
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* <LoadingComponent open={loading} /> */}
    </>
  );
};

export default ResetPassword;
